import React from 'react';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero" id="home">
      <h1>Smarter Stock Decisions Start Here</h1>
      <p>Get real-time stock insights, personalized recommendations, and more!</p>
      <div className="cta-buttons">
        <button
          className="cta-button"
          // onClick={() => document.getElementById('signup')?.scrollIntoView({ behavior: 'smooth' })}
        >
                    🔔 <a href="/AlartSetFormFixedPrice">Set Alerm</a>

        </button>
        <button
          className="cta-button secondary"
          // onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}
        >
          📊 <a href="/analysis">Stock Analysis</a>

        </button>

<button className="cta-button secondary">
  📈 <a href="/technical-analysis-dashboard">Technical Analysis</a>
</button>


      </div>
    </section>
  );
};

export default HeroSection;
